import React from "react";

import apneiaImg from "../../shared/img/apneia.jpg";
import contatoImg from "../../shared/img/contato.jpg";
import descubraImg from "../../shared/img/descubra.png";
import oqueeoxineoImg from "../../shared/img/oqueeoxineo.png";

// Componente para cada item da grade
const GridItem = ({ href, colSpan, rowSpan, image, text, gradientColor }) => (
  <a
    href={href}
    className={`
      group relative overflow-hidden block
      ${colSpan || ""}
      ${rowSpan || ""}
    `}
  >
    {/* Imagem de Fundo */}
    <div
      style={{ backgroundImage: `url(${image})` }}
      className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
    ></div>

    {/* Gradiente Overlay */}
    <div
      className={`absolute inset-x-0 bottom-0 h-2/3 group-hover:h-3/4 z-10
                  bg-gradient-to-t ${gradientColor}
                  transition-all duration-500 ease-out`}
    ></div>

    {/* Texto - igual ao modelo original */}
   <p className="absolute bottom-14 left-8 text-white z-20">
      {text}
    </p>
  </a>
);

export default function InfoGrid() {
  return (
    <section className="bg-[#f3f6f8] py-16 p-4 md:p-0">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 h-[500px] rounded-2xl shadow-lg overflow-hidden">
          <GridItem
            href="#"
            colSpan="md:col-span-2"
            image={descubraImg}
            text="Descubra a ventilação mecânica"
            gradientColor="from-[#108AFF]/80 to-transparent"
          />

          <GridItem
            href="#"
            rowSpan="md:row-span-2"
            image={contatoImg}
            text="Entre em contato e conheça sua melhor opção"
            gradientColor="from-[#108AFF]/80 to-transparent"
          />

          <GridItem
            href="#"
            image={apneiaImg}
            text="O que é apneia do sono?"
            gradientColor="from-[#108AFF]/80 to-transparent"
          />

          <GridItem
            href="#"
            image={oqueeoxineoImg}
            text="O que é oxigenoterapia?"
            gradientColor="from-[#108AFF]/80 to-transparent"
          />
        </div>
      </div>
    </section>
  );
}
